import { logger } from './logger';

class StorageService {
  constructor(storage = localStorage) {
    this.storage = storage;
  }

  set(key, value) {
    try {
      const serialized = JSON.stringify(value);
      this.storage.setItem(key, serialized);
      // logger.debug(`Storage: Set ${key}`, value);
    } catch (error) {
      logger.error(`Storage: Failed to set ${key}`, error);
      throw error;
    }
  }

  get(key, defaultValue = null) {
    try {
      const item = this.storage.getItem(key);
      if (item === null) return defaultValue;
      return JSON.parse(item);
    } catch (error) {
      logger.error(`Storage: Failed to get ${key}`, error);
      return defaultValue;
    }
  }

  remove(key) {
    try {
      this.storage.removeItem(key);
      // logger.debug(`Storage: Removed ${key}`);
    } catch (error) {
      logger.error(`Storage: Failed to remove ${key}`, error);
      throw error;
    }
  }

  clear() {
    try {
      this.storage.clear();
      // logger.debug('Storage: Cleared all items');
    } catch (error) {
      logger.error('Storage: Failed to clear', error);
      throw error;
    }
  }

  has(key) {
    return this.storage.getItem(key) !== null;
  }

  keys() {
    return Object.keys(this.storage);
  }
}

export const localStorage = new StorageService(window.localStorage);
export const sessionStorage = new StorageService(window.sessionStorage);

export default localStorage;
